import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";

import { AppointmentTypeConfirmationForm } from "@/components/appointment/type/appointment-type-confirmation-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetAppointmentTypeConfirmationPageQuery = graphql(`
  query GetAppointmentTypeConfirmationPageQuery(
    $codUsuario: Int!
    $codUsuarioCompromisso: Int!
  ) {
    ...AppointmentTypeConfirmationQueryFragment
  }
`);

const confirmationSearchSchema = z.object({
  /** Tipo de atendimento recém-criado, usado para montar o resumo. */
  appointmentTypeId: z.coerce.number().int().positive().optional(),
  /** Quantas agendas selecionadas a API recusou ao vincular. */
  agendasNaoVinculadas: z.coerce.number().optional(),
});

const CreateAppointmentTypeConfirmationPage = (): JSX.Element => {
  const { user } = Route.useRouteContext();
  const { appointmentTypeId, agendasNaoVinculadas } = Route.useSearch();

  const queryResult = useGraphQL(GetAppointmentTypeConfirmationPageQuery, {
    codUsuario: Number(user.codUsuario),
    codUsuarioCompromisso: appointmentTypeId ?? 0,
  });

  const { data } = queryResult;

  return (
    <RoundedLayout>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentTypeConfirmationForm
              data={data}
              notLinkedSchedulesCount={agendasNaoVinculadas ?? 0}
            />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/create/confirm",
)({
  validateSearch: confirmationSearchSchema,
  component: CreateAppointmentTypeConfirmationPage,
});
